import { connect } from 'react-redux';

import LearningAdminModulesTableList from '../components/LearningAdminModulesTableList';
import storage from '../../../../../lib/Storage';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import {
  loadModulesAdmin,
  loadModuleIdsAdmin,
  deleteModuleAdmin,
  deleteModulesAdmin,
  moduleAdminShowPreviewDetail,
} from '../../../../../state/modules/learningsAdmin/actions';
import { findStorageType } from '../../../../../lib/Auth';

const defaultScope = 'list';

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;

  const result = state.learningsAdmin.getIn([
    'modulesAdmin',
    defaultScope,
    partnershipId,
    'pages',
    order,
    limit,
    page,
  ]);

  return {
    partnershipId,
    isLoading: state.learningsAdmin.get('isLoading'),
    isLoadingIds: state.learningsAdmin.get('isLoadingIds'),
    total: state.learningsAdmin.getIn([
      'modulesAdmin',
      defaultScope,
      partnershipId,
      'totalModulesAdmin',
    ]),
    ids: state.learningsAdmin.get('ids').toArray(),
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['learningModulesAdmin', x]),
                schema.learningModuleAdmin,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
      : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadIds: (id, filter, cb) => {
      dispatch(loadModuleIdsAdmin(id, filter, cb));
    },
    load: (partnershipId, filter, page, limit, order, scope, cb) => {
      dispatch(
        loadModulesAdmin(partnershipId, filter, page, limit, order, scope, cb)
      );
    },
    remove: (partnershipId, id, cb) => {
      dispatch(deleteModuleAdmin(partnershipId, id, cb));
    },
    removes: (partnershipId, payload, cb) => {
      dispatch(deleteModulesAdmin(partnershipId, payload, cb));
    },
    showDetail: (moduleId) => {
      dispatch(moduleAdminShowPreviewDetail(moduleId));
    },
  };
};

const LearningAdminModulesTableListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModulesTableList);

export default LearningAdminModulesTableListContainer;
